import { ShouldRegisterIcon } from 'common/Icons';
import { useRouter } from 'common/hooks/useRouter';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setAccountActivationStep } from 'redux/common/AccountActivationSlice';

const ShouldRegister = () => {
  //
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { navigate } = useRouter();

  const onRefuse = () => {
    dispatch(setAccountActivationStep('Agreement'));
    navigate.pushLogin();
  };

  return (
    <div className="flex flex-col gap-6 items-center">
      <h1 className="text-5xl font-bold text-center text-L-info-100 mt-4">
        {t(
          `BrokerCode_${window.api?.BROKER_CODE}.Activation.should_register_label`
        )}
      </h1>
      <ShouldRegisterIcon />
      <span className="text-xl px-4 text-center !leading-8 !font-medium md:text-b2xl  text-L-primary-50 ">
        {t(
          `BrokerCode_${window.api?.BROKER_CODE}.Activation.should_register_details`
        )}
      </span>
      <div className="w-full mt-12">
        <a
          href={'https://account.irfarabi.com/reg/?j=1'}
          className="w-full block text-center bg-L-secondary-50 dark:bg-D-secondary-50  rounded text-L-basic dark:text-D-basic p-2 text-3xl mb-6"
        >
          {t(
            `BrokerCode_${window.api?.BROKER_CODE}.Activation.register_in_broker`
          )}
        </a>
        <p
          onClick={onRefuse}
          className="text-center cursor-pointer text-L-primary-50 text-xl md:text-b2xl lg:text-2xl mb-2"
        >
          {t('FormSide.BackText')}
        </p>
      </div>
    </div>
  );
};

export default ShouldRegister;
